var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import "./heapElements/ListComponent";
import "./heapElements/TupleComponent";
import "./heapElements/SetComponent";
import "./heapElements/DictComponent";
import "./heapElements/InstanceComponent";
import "./heapElements/ClassComponent";
import "./heapElements/FunctionComponent";
import "./heapElements/HeapPrimitiveComponent";
import "./heapElements/OtherComponent";
import { defaults } from "../style";
import { deepAwaitMixin } from "../mixins/DeepAwaitMixin";
let HeapElementComponent = class HeapElementComponent extends deepAwaitMixin(LitElement) {
    render() {
        if (this.el === undefined)
            return html ``;
        switch (this.el[0]) {
            case "LIST":
                return html `<tc-list .el=${this.el}></tc-list>`;
            case "TUPLE":
                return html `<tc-tuple .el=${this.el}></tc-tuple>`;
            case "SET":
                return html `<tc-set .el=${this.el}></tc-set>`;
            case "DICT":
                return html `<tc-dict .el=${this.el}></tc-dict>`;
            case "INSTANCE":
                return html `<tc-instance .el=${this.el}></tc-instance>`;
            case "INSTANCE_PPRINT":
                return html `<tc-instance .el=${this.el}></tc-instance>`;
            case "CLASS":
                return html `<tc-class .el=${this.el}></tc-class>`;
            case "FUNCTION":
                return html `<tc-function .el=${this.el}></tc-function>`;
            case "HEAP_PRIMITIVE":
                return html `<tc-heap-primitive .el=${this.el}></tc-heap-primitive>`;
            default:
                return html `<tc-other .el=${this.el}></tc-other>`;
        }
    }
};
HeapElementComponent.styles = [defaults];
__decorate([
    property({ type: Array })
], HeapElementComponent.prototype, "el", void 0);
HeapElementComponent = __decorate([
    customElement('tc-heap-element')
], HeapElementComponent);
export { HeapElementComponent };
//# sourceMappingURL=HeapElementComponent.js.map